import channels from "./channels";

export const homeChannels = [
  channels.android,
  channels.ios,
  channels.minhaclaro_app,
  channels.minhaclaro_web,
];
